import { MARQUEE_ITEMS } from "@/data";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section data-testid="marquee-section" className="marquee-paused relative py-8 border-y border-white/10 bg-[#0C1B2E] overflow-hidden">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center font-display text-lg sm:text-xl font-semibold tracking-wide text-[#9DAEC4]/70">
            <span className="px-6">{item}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#D9A441]/70" />
          </span>
        ))}
      </div>
    </section>
  );
}
